import { useEffect, useRef } from 'react'

export const useNavigateToNewRow = (): {
    goToNewRow: () => void
    classNameNewRow: string
    removeClassFromElement: (el: HTMLElement) => void
    removeNewRowStyle: () => void
    newElements: NodeListOf<HTMLTableRowElement>
} => {
    const classNameNewRow = 'new-row'

    const refElements = useRef<NodeListOf<HTMLTableRowElement>>(null)

    const goToNewRow = (): void => {
        const newRow = document.querySelector(`.${classNameNewRow}`)

        if (newRow) {
            newRow.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' })
            removeNewRowStyle()
        }
    }

    const removeNewRowStyle = (): void => {
        refElements.current = document.querySelectorAll(`.${classNameNewRow}`)

        if (refElements.current) {
            refElements.current.forEach(element => {
                element.addEventListener('mousedown', () => {
                    removeClassFromElement(element)
                })
            })
        }
    }

    const removeClassFromElement = (el: HTMLElement): void => {
        el?.classList?.remove(classNameNewRow)
    }

    useEffect(() => {
        return () => {
            if (refElements.current) {
                refElements.current.forEach(element => {
                    element.removeEventListener('mousedown', () => {
                        removeClassFromElement(element)
                    })
                })
                refElements.current = null
            }
        }
    }, [])

    return {
        goToNewRow,
        classNameNewRow,
        removeClassFromElement,
        removeNewRowStyle,
        newElements: refElements.current
    }
}
